export default __webpack_public_path__ + "static/media/eyespots.a5fffecc.png";